@let hasDeletions =
  actionsEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal();

<atn-ds-page>
  <atn-ds-table [config]="actionsTableConfig" />
</atn-ds-page>

<atn-mosaic-dev-action-dialog />

@if (hasDeletions) {
  <atn-ds-confirmation-overlay
    title="Delete action"
    description="Are you sure you want to delete this action?"
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
  />
}
